import { BaseService, Service } from "/@/cool";
// const localHttpPrefix = "https://192.168.88.2:8200";

@Service("shopExternalOrder")
class ShopExternalOrder extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["createCustomerAndPid"] = prefix + "createCustomerAndPid";
		this.permission["updateCoverForExteralOrder"] = prefix + "updateCoverForExteralOrder";
		this.permission["checkExternalOrderShopMoney"] = prefix + "checkExternalOrderShopMoney";
		this.permission["getExternalOrderCancelReason"] = prefix + "getExternalOrderCancelReason";
		this.permission["updateOrderMoney"] = prefix + "updateOrderMoney";
		this.permission["changeOrderRemarkForExternalOrder"] =
			prefix + "changeOrderRemarkForExternalOrder";
		this.permission["getExternalOrderMemo"] = prefix + "getExternalOrderMemo";
		this.permission["getCustomerForExternalOrder"] = prefix + "getCustomerForExternalOrder";
		this.permission["addModelHeadsPoseAndPetProp"] = prefix + "addModelHeadsPoseAndPetProp";
		this.permission["pushBuildFile"] = prefix + "pushBuildFile";
		this.permission["getExternalPid"] = prefix + "getExternalPid";
		this.permission["confirmExternalOrder"] = prefix + "confirmExternalOrder";
		this.permission["putSignUrlForExternalOrder"] = prefix + "putSignUrlForExternalOrder";
		this.permission["getExternalProduct"] = prefix + "getExternalProduct";
		this.permission["getPackagingSelects"] = prefix + "getPackagingSelects";
		this.permission["downloadBaseModel"] = prefix + "downloadBaseModel";
		this.permission["estimateExternalRepairFee"] = prefix + "estimateExternalRepairFee";
		// this.permission["addUploadQueue"] = prefix + "addUploadQueue";
		// this.permission["photos"] = prefix + "photos";
		// this.permission["check"] = prefix + "check";
		// this.permission["shakeCheckImage"] = prefix + "shakeCheckImage";
		// this.permission["preview"] = prefix + "preview";
	}

	pushBuildFile(data: any) {
		return this.request({
			url: "/pushBuildFile",
			method: "POST",
			data
		});
	}
	createCustomerAndPid(data: any) {
		return this.request({
			url: "/createCustomerAndPid",
			method: "POST",
			data
		});
	}

	updateCoverForExteralOrder(data: any) {
		return this.request({
			url: "/updateCoverForExteralOrder",
			method: "POST",
			data
		});
	}
	addModelHeadsPoseAndPetProp(data: any) {
		return this.request({
			url: "/addModelHeadsPoseAndPetProp",
			method: "POST",
			data
		});
	}

	checkExternalOrderShopMoney(data: any) {
		return this.request({
			url: "/checkExternalOrderShopMoney",
			method: "POST",
			data
		});
	}

	getExternalOrderCancelReason(data: any) {
		return this.request({
			url: "/getExternalOrderCancelReason",
			method: "POST",
			data
		});
	}

	//修改订单金额
	updateOrderMoney(data: any) {
		return this.request({
			url: "/changOrderMoneyForExternalOrder",
			method: "POST",
			data
		});
	}

	//修改订单备注
	changeOrderRemarkForExternalOrder(data: any) {
		return this.request({
			url: "/changeOrderRemarkForExternalOrder",
			method: "POST",
			data
		});
	}

	//获取订单备注
	getExternalOrderMemo(data: any) {
		return this.request({
			url: "/getExternalOrderMemo",
			method: "POST",
			data
		});
	}

	//根据门店id获取客户的信息
	getCustomerForExternalOrder(data: any) {
		return this.request({
			url: "/getCustomerForExternalOrder",
			method: "POST",
			data
		});
	}
	getExternalPid(data: any) {
		return this.request({
			url: "/getExternalPid",
			method: "POST",
			data
		});
	}
	confirmExternalOrder(data: any) {
		return this.request({
			url: "/confirmExternalOrder",
			method: "POST",
			data
		});
	}
	putSignUrlForExternalOrder(data: any) {
		return this.request({
			url: "/putSignUrlForExternalOrder",
			method: "POST",
			data
		});
	}
	getExternalProduct(data: any) {
		return this.request({
			url: "/getExternalProduct",
			method: "POST",
			data
		});
	}
	getPackagingSelects(data: any) {
		return this.request({
			url: "/getPackagingSelects",
			method: "POST",
			data
		});
	}

	getUploadSign() {
		return this.request({
			url: "/getUploadSign",
			method: "POST"
		});
	}

	getMainCount(data: { path: string }) {
		return this.request({
			url: "/getMainCount",
			method: "POST",
			data
		});
	}

	// 下载怀江 base 模型（单条/批量）
	downloadBaseModel(data: { shop_id: number; order_id?: number; order_ids?: number[] }) {
		return this.request({
			url: "/downloadBaseModel",
			method: "POST",
			data
		});
	}

	// 估算外部修模费
	estimateExternalRepairFee(data: { shop_id: number; order_id?: number }) {
		return this.request({
			url: "/estimateExternalRepairFee",
			method: "POST",
			data
		});
	}
}
export default ShopExternalOrder;
